import { ContainerEnvironment } from '@fluidx/office-fluid-types';

/**
 * Gets the baseURL with ring path for the provided container environment. Defaults to production
 */
export function getCdnBaseUrl(environment: keyof typeof ContainerEnvironment | undefined): string {
  switch (environment) {
    case ContainerEnvironment.Staging:
      return 'https://cdn.dev.fluidpreview.office.net/fluid/stg';
    case ContainerEnvironment.Dogfood:
      return 'https://cdn.fluidpreview.office.net/fluid/df';
    case ContainerEnvironment.Gcc:
      return 'https://cdn.fluidpreview.office.net/fluid/gcc';
    default:
      return 'https://cdn.fluidpreview.office.net/fluid/prod';
  }
}
